module.exports = __webpack_public_path__ + "static/top-web-designers-2020-7ab3a36ef1071b053cd65bf23b915470.png";